import setFolderPaneCollapsedState from '../utils/setFolderPaneCollapsedState';
import { logVerboseUsage } from 'owa-analytics';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getBrowserWidth } from 'owa-mail-store-actions';
import { FolderPaneExpansionSource, MailModuleStore, getStore } from 'owa-mail-store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetShowFolderPaneState {
    mailModule: MailModuleStore;
}

/**
 * Sets folder pane expansion state
 * @param folderPaneExpansionSource the source of the folder pane expansion
 * @param state set show folder pane state
 */
export default select<SetShowFolderPaneState>({
    mailModule: () => getStore().mailModule,
})(
    action('setShowFolderPane')(function setShowFolderPane(
        folderPaneExpansionSource: FolderPaneExpansionSource,
        state?: SetShowFolderPaneState
    ) {
        const browserWidth = getBrowserWidth();
        const isFolderPaneCollapsed = getIsBitSet(ListViewBitFlagsMasks.FolderPaneCollapsed);

        logVerboseUsage('TnS_FolderPaneChange', [
            folderPaneExpansionSource.toString(),
            isFolderPaneCollapsed,
            state.mailModule.showFolderPane,
            true /* isInNonDynamicFolderExpansionMode */,
            browserWidth,
        ]);

        switch (folderPaneExpansionSource) {
            case FolderPaneExpansionSource.LeftNavResizeExpand:
            case FolderPaneExpansionSource.ToggleExpand:
                state.mailModule.showFolderPane = true;
                setFolderPaneCollapsedState(false /* isCollapsed */);
                return;

            case FolderPaneExpansionSource.ToggleCollapse:
                state.mailModule.showFolderPane = false;
                setFolderPaneCollapsedState(true /* isCollapsed */);
                return;

            case FolderPaneExpansionSource.Init:
                // Read the collapse state from user config option when OWA boots
                const isFolderPaneCollapsed = getIsBitSet(
                    ListViewBitFlagsMasks.FolderPaneCollapsed
                );
                state.mailModule.showFolderPane = !isFolderPaneCollapsed;
                return;

            case FolderPaneExpansionSource.WindowResize:
            case FolderPaneExpansionSource.Auto:
            default:
                // No dynamic support yet.
                return;
        }
    })
);
